import { Skeleton, Stack, SxProps } from "@mui/material";

interface IProps {
  sx?: SxProps;
}
const LinearScaleResultSkeleton = (props: IProps) => {
  return (
    <Stack spacing={0.5} sx={props.sx}>
      <Skeleton variant="rectangular" height={25} />
      <Skeleton variant="rectangular" height={25} width="50%" />
      <Skeleton variant="rectangular" height={150} />
    </Stack>
  );
};

export { LinearScaleResultSkeleton };
